module.exports = __webpack_public_path__ + "img/ip4.35166fcc.png";